module.exports = __webpack_public_path__ + "static/lang4ulogo-alt-64a1c55499f3b3a9861dd760bcb7075a.png";